<div *ngIf="rows.length>0">
    <div [formGroup]="form" >
        <div *ngIf="!stackInputs">
            <div *ngFor="let row of rows">
                <div class="row">
                    <div *ngFor="let col of row" class="col-3">
                        <dynamic-input [disabled]="disabled" [input]="col" [form]="form"></dynamic-input>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="stackInputs">
            <div *ngFor="let row of rows">
                <div class="row">
                    <div *ngFor="let col of row" class="col-12">
                        <dynamic-input [disabled]="disabled" [input]="col" [form]="form"></dynamic-input>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
